export default {
  title: 'Panoramic Restaurant in Valdobbiadene | Osteria alla Terrazza',
  titleMenu: 'Traditional Veneto menu | Osteria alla Terrazza',
  titleWine: 'Prosecco Valdobbiadene wine list | Osteria alla Terrazza',
  description:
    'Restaurant on the Prosecco Wine Road with local cuisine, DOCG Prosecco, aperitivo and vineyard views in the UNESCO hills.',
  descriptionWine:
    'Wine list featuring Valdobbiadene Prosecco and local selections: by-the-glass and bottle options, with pairings designed to highlight the flavours of traditional cuisine.',
  descriptionMenu:
    'Seasonal menu of traditional Veneto cuisine: starters, pasta and main courses, local ingredients and daily specials with a vineyard view.',
}
